import axios from 'axios'

import { getApiUrl } from '../../util/api/api'

const resumeJob = (id: string): Promise<any> => {
  try {
    return axios.put(getApiUrl(`/dashboard/api/job/resume/${id}`))
  } catch (error) {
    throw new Error(`An error has occurred while resuming a job: ${error.message}`)
  }
}

export default resumeJob
